import { Box } from '@mui/material';
import { useGetServiceAgreementsForCompany } from 'ogp/hooks/queryHooks/service-agreements/use-get-service-agreements-for-company';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { Header, Page, Toolbox } from 'redesign';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { ServiceAgreementList } from './components/service-agreement-list/service-agreement-list';

export const SupplierManagementDataProvider = () => {
  const serviceAgreementsQuery = useGetServiceAgreementsForCompany({ isBorrower: true });

  if (serviceAgreementsQuery.status !== 'success' || !serviceAgreementsQuery.data) {
    return <RenderUnsettledUI data={serviceAgreementsQuery} />;
  }

  const suppliers = serviceAgreementsQuery.data.filter(
    (agreement) => agreement.serviceAgreementPartyRole === 'BORROWER'
  );

  return <SupplierManagement data={suppliers} />;
};

const SupplierManagement = ({ data }: { data: ServiceAgreementsResponse }) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Page
      header={
        <Header
          titleText={t('collegial-lending.suppliers.title', {
            defaultValue: 'Service account for Suppliers',
          })}
        />
      }
      toolbox={<Toolbox />}
    >
      <Box width="100%">
        <ServiceAgreementList data={data} role="BORROWER" />
      </Box>
    </Page>
  );
};
